import React from 'react';
import { Link } from 'react-router-dom';
import useSeo from '../hooks/useSeo';
import './Pages.css';

function Home() {
  useSeo(
    'Rev-Tech | Managed IT & Cybersecurity Consulting',
    'Rev-Tech delivers managed IT services, cybersecurity consulting, and project support for businesses across the United States.',
    {
      ogTitle: 'Rev-Tech | Managed IT & Cybersecurity Consulting',
      ogDescription: 'Managed IT services, cybersecurity consulting, and technical project support for businesses across the United States.',
      twitterTitle: 'Rev-Tech | Managed IT & Cybersecurity Consulting',
      twitterDescription: 'Managed IT services, cybersecurity consulting, and technical project support for businesses across the United States.',
      canonical: 'https://www.rev-technology.com/'
    }
  );

  return (
    <div className="page">
      <section className="hero">
        <h1>Welcome to Rev-Tech!</h1>
        <p className="hero-copy">Your trusted provider of managed services and cybersecurity consulting in the Greater Tampa Bay Area, delivering proactive IT management, security, cloud backup, and project expertise.</p>
        <Link to="/contact" className="cta-button">Contact Us</Link>
      </section>
      
      <section className="content-section">
        <h2>Why Choose Us?</h2>
        <div className="features-grid">
          <div className="feature-card">
            <h3>Expert IT Support</h3>
            <p>Experienced and certified team managing your technology infrastructure 24/7</p>
          </div>
          <div className="feature-card">
            <h3>Proactive Monitoring</h3>
            <p>Prevent issues before they impact your business</p>
          </div>
          <div className="feature-card">
            <h3>Cybersecurity Done Right</h3>
            <p>Protect your business from evolving cyber threats</p>
          </div>
          <div className="feature-card">
            <h3>Local Expertise</h3>
            <p>Deep knowledge of Tampa Bay businesses and local needs</p>
          </div>
        </div>
      </section>

      <section className="content-section msp-section">
        <h2>What We Do</h2>
        <p>
          Rev-Tech is a managed service provider dedicated to helping businesses of all sizes focus on what matters most—growing your business. We handle the complexity of managing your IT infrastructure, so you don't have to.
        </p>
        <div className="services-overview">
          <div className="service-overview-item">
            <h3>Infrastructure Management</h3>
            <p>Complete management of your servers, networks, and systems to ensure optimal performance and reliability.</p>
          </div>
          <div className="service-overview-item">
            <h3>Security & Compliance</h3>
            <p>Advanced threat detection, security assessments, and compliance support to protect your business and data.</p>
          </div>
          <div className="service-overview-item">
            <h3>Cloud Solutions</h3>
            <p>Seamless cloud migration and management services tailored to your business needs and budget.</p>
          </div>
          <div className="service-overview-item">
            <h3>Responsive Support</h3>
            <p>Fast, friendly technical support from our expert helpdesk team available when you need us.</p>
          </div>
        </div>
      </section>

      <section className="content-section benefits-section">
        <h2>The MSP Advantage</h2>
        <div className="benefits-list">
          <div className="benefit-item">
            <span className="benefit-icon">✓</span>
            <div className="benefit-text">
              <h4>Reduced IT Costs</h4>
              <p>Predictable, manageable monthly costs instead of unexpected emergency repairs</p>
            </div>
          </div>
          <div className="benefit-item">
            <span className="benefit-icon">✓</span>
            <div className="benefit-text">
              <h4>Increased Productivity</h4>
              <p>Less downtime means your team stays focused and productive</p>
            </div>
          </div>
          <div className="benefit-item">
            <span className="benefit-icon">✓</span>
            <div className="benefit-text">
              <h4>Enhanced Security</h4>
              <p>Advanced protection and continuous monitoring keep your business safe</p>
            </div>
          </div>
          <div className="benefit-item">
            <span className="benefit-icon">✓</span>
            <div className="benefit-text">
              <h4>Peace of Mind</h4>
              <p>Knowing experts are managing your technology 24/7</p>
            </div>
          </div>
        </div>
      </section>

      <section className="content-section msp-section">
        <h2>Consulting & Project Support</h2>
        <p>
          In addition to managed services, Rev-Tech offers cybersecurity consulting, audit preparation, DoD contract support,
          and skilled technical project delivery. We help your business stay compliant, secure, and ready for mission-critical work.
        </p>
        <div className="services-overview">
          <div className="service-overview-item">
            <h3>Cybersecurity Consulting</h3>
            <p>Security assessments, remediation planning, and strategy development to strengthen your defenses.</p>
          </div>
          <div className="service-overview-item">
            <h3>Audit Readiness</h3>
            <p>Documentation, evidence preparation, and control reviews to help you pass compliance audits.</p>
          </div>
          <div className="service-overview-item">
            <h3>DoD Contract Support</h3>
            <p>Assistance with contract security requirements, NIST alignment, and CMMC readiness.</p>
          </div>
          <div className="service-overview-item">
            <h3>Technical Project Talent</h3>
            <p>Specialized resources for infrastructure hardening, secure deployments, and complex IT projects.</p>
          </div>
        </div>
      </section>

      <section className="content-section cta-section">
        <h2>Ready to Transform Your IT?</h2>
        <p>Let Rev-Tech handle your technology so you can focus on growing your business.</p>
        <Link to="/contact" className="cta-button large">Get Started Today</Link>
      </section>
    </div>
  );
}

export default Home;
